module.exports = __webpack_public_path__ + "static/img/sm_18.7909d2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_18.png
// module id = 1/s/
// module chunks = 0